import "core-js/modules/es.array.map.js";
import { getProductTypesByCategory } from '@finect/front-resources/Products';
export var getProductTypesByCategoryRegex = function getProductTypesByCategoryRegex(category) {
  return getProductTypesByCategory(category).map(function (_ref) {
    var slug = _ref.slug;
    return slug;
  }).join('|');
};